import React from "react";
import { Breadcrumb as AntdBreadcrumb } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
export function Breadcrumb({ title = "" }) {
  const navigate = useNavigate();
  const split_title = title.split(",");
  const items = [
    {
      title: "Home",
    },
  ];
  split_title.forEach((splitItem) => {
    items.push({
      title: splitItem.trim(),
    });
  });
  return (
    <div className="table_head">
      <p onClick={() => navigate(-1)} className="go_back">
        <ArrowLeftOutlined /> &nbsp;Back
      </p>
      <AntdBreadcrumb items={items} />
    </div>
  );
}
